// src/App.js
import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import Layout from "./components/Layout";
import Home from "./components/Home";
import Login from "./components/Login";
import Register from "./components/Register";
import ForgotPassword from "./components/ForgotPassword";

import AdminDashboard from "./components/AdminDashboard";
import InstructorDashboard from "./components/InstructorDashboard";
import StudentDashboard from "./components/StudentDashboard";

import FileUpload from "./components/FileUpload";
import AssignSessionForm from "./components/AssignSessionForm";
import AdminReleaseMaterial from "./components/AdminReleaseMaterial";
import VideoPlayer from "./components/VideoPlayer";
import AdminQuestionPanel from "./components/AdminQuestionPanel";
import AdminAssignExam from "./components/AssignExam";
import StudentExamPage from "./components/StudentExamPage";
import VerifySuccess from "./components/VerifySuccess";
import VerifyError from "./components/VerifyError";
import ViewQuestionsPage from "./components/ViewQuestionsPage";
import ResultsPage from "./components/ResultsPage";

import RoleRoute from "./components/RoleRoute"; 
import FeedbackForm from "./components/FeedbackForm";
import ExamResultDetails from "./components/ExamResultDetails";
import StudentResultsPage from "./components/StudentResultsPage";



function App() {
  const [userName, setUserName] = useState(localStorage.getItem("userName") || "");
  const [userRole, setUserRole] = useState("");
  const [roles, setRoles] = useState([]);

  useEffect(() => {
  const role = localStorage.getItem("activeRole");
  if (role) {
    setUserRole(role);
  }
}, []);


  /*useEffect(() => {
    const storedRoles = JSON.parse(localStorage.getItem("roles")) || [];
    setRoles(storedRoles);

    if (!localStorage.getItem("activeRole") && storedRoles.length > 0) {
      localStorage.setItem("activeRole", storedRoles[0]);
      setUserRole(storedRoles[0]);
    }
  }, []);*/

  const getDashboardByRole = (role) => {
    switch (role) {
      case "Admin":
        return <Navigate to="/dashboard/admin" replace />;
      case "Instructor":
        return <Navigate to="/dashboard/instructor" replace />;
      case "Student":
        return <Navigate to="/dashboard/student" replace />;
      default:
        return <Navigate to="/login" replace />;
    }
  };

  return (
    <Router basename="/"> 
      <Routes>
        {/* Public */}
        <Route path="/login" element={<Login setUserName={setUserName} setUserRole={setUserRole} />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/" element={<Home />} />

        {/* Protected Layout */}
        <Route
          element={
            <Layout
              userName={userName}
              userRole={userRole}
              setUserName={setUserName}
              setUserRole={setUserRole}
            />
          }
        >

          {/* DASHBOARDS (Role Protected) */}
          <Route
            path="/dashboard/admin"
            element={
              <RoleRoute role={userRole} allowed={["Admin"]}>
                <AdminDashboard />
              </RoleRoute>
            }
          />

          <Route
            path="/dashboard/instructor"
            element={
              <RoleRoute role={userRole} allowed={["Instructor"]}>
                <InstructorDashboard />
              </RoleRoute>
            }
          />

          <Route
            path="/dashboard/student"
            element={
              <RoleRoute role={userRole} allowed={["Student"]}>
                <StudentDashboard />
              </RoleRoute>
            }
          />

          {/* ADMIN ONLY ROUTES */}
          <Route
            path="/admin/upload"
            element={
              <RoleRoute role={userRole} allowed={["Admin"]}>
                <FileUpload />
              </RoleRoute>
            }
          />

          <Route
            path="/admin/assign-session"
            element={
              <RoleRoute role={userRole} allowed={["Admin"]}>
                <AssignSessionForm />
              </RoleRoute>
            }
          />

          <Route
            path="/admin/release-material"
            element={
              <RoleRoute role={userRole} allowed={["Admin"]}>
                <AdminReleaseMaterial />
              </RoleRoute>
            }
          />

          <Route
            path="/admin/exams"
            element={
              <RoleRoute role={userRole} allowed={["Admin"]}>
                <AdminQuestionPanel />
              </RoleRoute>
            }
          />

          <Route
            path="/admin/assign-exam"
            element={
              <RoleRoute role={userRole} allowed={["Admin"]}>
                <AdminAssignExam />
              </RoleRoute>
            }
          />
          <Route
            path="/admin/results"
            element={
              <RoleRoute role={userRole} allowed={["Admin"]}>
                <ResultsPage />
              </RoleRoute>
            }
          />
          <Route
            path="/admin/results"
            element={
              <RoleRoute role={userRole} allowed={["Admin", "Instructor"]}>
                <ResultsPage />
              </RoleRoute>
            }
          />
          <Route
            path="/results/attempt/:attemptId"
            element={
              <RoleRoute
                role={userRole}
                allowed={["Admin", "Instructor", "Student"]}
              >
                <ExamResultDetails />
              </RoleRoute>
  }
/>

              <Route
                path="/student/results"
                element={<StudentResultsPage />}
              />
                  <Route
                  path="/instructor/results"
                  element={
                    <RoleRoute role={userRole} allowed={["Instructor"]}>
                      <ResultsPage />
                    </RoleRoute>
                  }
                />
              <Route
                path="/instructor/results"
                element={
                  <RoleRoute
                    role={userRole}
                    allowed={["Instructor", "Admin"]}
                  >
                    <ResultsPage />
                    </RoleRoute>
        }
      />
        </Route>
          {/* STUDENT / SHARED ROUTES */}
          <Route path="/watch/:filename" element={<VideoPlayer />} />
          <Route path="/student-exam/:examId/:userId" element={<StudentExamPage />} />
          <Route path="/view-questions/:courseId/:examId" element={<ViewQuestionsPage />} />

          {/* VERIFICATION */}
          <Route path="/verify-success" element={<VerifySuccess />} />
          <Route path="/verify-error" element={<VerifyError />} />

          {/* Intelligent Redirection */}
          <Route path="/dashboard" element={getDashboardByRole(userRole)} />
       
      </Routes>
    </Router>
  );
}

export default App;
